import gql from "graphql-tag";

export const ACCEPT_CONNECTION_MUTATION = gql`
  mutation AcceptUserConnectionInvitation($userId: Int!) {
    acceptUserConnection(data: { userId: $userId })
  }
`;
